import { Box, TextArea, type TextAreaProps } from '@ui-lib';

import { LockButton } from '../LockableTextField/LockButton';

interface LockableTextAreaProps extends Omit<TextAreaProps, 'adornment' | 'adornmentPosition'> {
  locked?: boolean;
  toggleLocked?: () => void;
}

export const LockableTextArea = ({
  ref: forwardedRef,
  locked,
  toggleLocked,
  ...restProps
}: LockableTextAreaProps & {
  ref?: React.Ref<HTMLTextAreaElement>;
}) => (
  <TextArea
    ref={forwardedRef}
    disabled={locked}
    adornment={
      locked !== undefined ? (
        <Box marginRight="xsmall">
          <LockButton locked={locked} toggleLocked={toggleLocked} />
        </Box>
      ) : undefined
    }
    adornmentPosition="top-right"
    {...restProps}
  />
);

LockableTextArea.displayName = 'LockableTextArea';
